/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { Checkbox, Space } from '@ui/components';

export const UncheckedCheckboxExample = () => (
    <Checkbox>Include in report</Checkbox>
);

export const CheckedCheckboxExample = () => (
    <Checkbox defaultChecked>Include in report</Checkbox>
);

export const IndeterminateCheckboxExample = () => (
    <Checkbox indeterminate>Some placements selected</Checkbox>
);

export const DisabledCheckboxExample = () => (
    <Checkbox disabled>Locked selection</Checkbox>
);

export const DisabledCheckedCheckboxExample = () => (
    <Checkbox checked disabled>
        Always included
    </Checkbox>
);

export const GroupCheckboxExample = () => (
    <Checkbox.Group
        defaultValue={['broadcast']}
        options={[
            { label: 'Broadcast', value: 'broadcast' },
            { label: 'Social', value: 'social' },
            { label: 'Print', value: 'print', disabled: true },
        ]}
    />
);

export const VerticalGroupCheckboxExample = () => (
    <Checkbox.Group defaultValue={['social']}>
        <Space direction="vertical">
            <Checkbox value="broadcast">Broadcast</Checkbox>
            <Checkbox value="social">Social</Checkbox>
            <Checkbox value="print">Print</Checkbox>
        </Space>
    </Checkbox.Group>
);
